'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Site(id, created, deleted, account, active, name, url, twoFactorAuth, expressLogin, credentials, signer, realm, scope, system, login, path) {
  this.e0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.L2 = null;
  this.L3 = null;
  this.u2 = null;
  this.L1 = false;
  this.kg = null;
  this.n5 = null;
  this.ot = false;
  this.u3 = false;
  this.rL = null;
  this.u5 = null;
  this.os = null;
  this.qk = null;
  this.rM = null;
  this.u4 = null;
  this.E2 = null;
  this.e0 = id;
  this.L2 = created;
  this.L3 = deleted;
  this.u2 = account;
  this.L1 = active;
  this.kg = name;
  this.n5 = url;
  this.ot = twoFactorAuth;
  this.u3 = expressLogin;
  this.rL = credentials;
  this.u5 = signer;
  this.os = realm;
  this.qk = scope;
  this.rM = system;
  this.u4 = login;
  this.E2 = path;
}
export { $c_Lpresto_types$Site as $c_Lpresto_types$Site };
$p = $c_Lpresto_types$Site.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Site;
/** @constructor */
function $h_Lpresto_types$Site() {
}
export { $h_Lpresto_types$Site as $h_Lpresto_types$Site };
$h_Lpresto_types$Site.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Site"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.e0;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().br(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.L2));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.L3));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.u2));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.L1 ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.kg));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.n5));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.ot ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.u3 ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.rL));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.u5));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.os));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.qk));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.rM));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.u4));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.E2));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 16);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Site)) {
    if ((((this.L1 === x$0.L1) && (this.ot === x$0.ot)) && (this.u3 === x$0.u3))) {
      var this$1 = this.e0;
      var b = x$0.e0;
      var $x_10 = ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x = this.L2;
      var x$2 = x$0.L2;
      var $x_9 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$3 = this.L3;
      var x$4 = x$0.L3;
      var $x_8 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$5 = this.u2;
      var x$6 = x$0.u2;
      var $x_7 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_7 = false;
    }
    if ((($x_7 && (this.kg === x$0.kg)) && (this.n5 === x$0.n5))) {
      var x$7 = this.rL;
      var x$8 = x$0.rL;
      var $x_6 = ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$9 = this.u5;
      var x$10 = x$0.u5;
      var $x_5 = ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$11 = this.os;
      var x$12 = x$0.os;
      var $x_4 = ((x$11 === null) ? (x$12 === null) : x$11.i(x$12));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$13 = this.qk;
      var x$14 = x$0.qk;
      var $x_3 = ((x$13 === null) ? (x$14 === null) : x$13.i(x$14));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$15 = this.rM;
      var x$16 = x$0.rM;
      var $x_2 = ((x$15 === null) ? (x$16 === null) : x$15.i(x$16));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$17 = this.u4;
      var x$18 = x$0.u4;
      var $x_1 = ((x$17 === null) ? (x$18 === null) : x$17.i(x$18));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$19 = this.E2;
      var x$20 = x$0.E2;
      return ((x$19 === null) ? (x$20 === null) : x$19.i(x$20));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 16;
});
$p.s = (function() {
  return "Site";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.e0;
      break;
    }
    case 1: {
      return this.L2;
      break;
    }
    case 2: {
      return this.L3;
      break;
    }
    case 3: {
      return this.u2;
      break;
    }
    case 4: {
      return this.L1;
      break;
    }
    case 5: {
      return this.kg;
      break;
    }
    case 6: {
      return this.n5;
      break;
    }
    case 7: {
      return this.ot;
      break;
    }
    case 8: {
      return this.u3;
      break;
    }
    case 9: {
      return this.rL;
      break;
    }
    case 10: {
      return this.u5;
      break;
    }
    case 11: {
      return this.os;
      break;
    }
    case 12: {
      return this.qk;
      break;
    }
    case 13: {
      return this.rM;
      break;
    }
    case 14: {
      return this.u4;
      break;
    }
    case 15: {
      return this.E2;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.E = (function() {
  return this.kg;
});
$p.afC = (function() {
  return this.n5;
});
$p.csY = (function() {
  return this.u4;
});
$p.GP = (function() {
  return ("s#" + this.e0);
});
$p.ae5 = (function(nameOrUrl) {
  var lower = nameOrUrl.toLowerCase();
  var this$1 = this.kg;
  var this$2 = this$1.toLowerCase();
  if (((this$2.indexOf(lower) | 0) !== (-1))) {
    return true;
  } else {
    var this$3 = this.n5;
    var this$4 = this$3.toLowerCase();
    return ((this$4.indexOf(lower) | 0) !== (-1));
  }
});
$p.jk = (function() {
  return this.e0;
});
function $isArrayOf_Lpresto_types$Site(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kc)));
}
export { $isArrayOf_Lpresto_types$Site as $isArrayOf_Lpresto_types$Site };
var $d_Lpresto_types$Site = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Site, "presto.types$Site", ({
  kc: 1,
  aA: 1,
  kd: 1,
  ee: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Site as $d_Lpresto_types$Site };
//# sourceMappingURL=presto.types$-Site.js.map
